const trimWhiteSpacesFromString = (string?: string | null) => {
  return string && string.replace(/ /g,'')
}

export default trimWhiteSpacesFromString